import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('receive_by_email'),
    externalSubmitterRequiredValidationText: defineMessage('please_select_a_submitter'),
    chooseSubmitter: defineMessage('choose_a_submitter'),
    emailAddressLabel: defineMessage('email_address'),
    requestStatusLabel: defineMessage('request_status'),
    draftStatusText: defineMessage('draft'),
    onReviewStatusText: defineMessage('on_review'),
    learnMore: defineMessage('learn_more'),
    copiedToClipboard: defineMessage('copied_to_clipboard'),
    setupButtonText: defineMessage('setup'),
};
